





























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import {getFormatDate} from '@/utils/common'
import widgetCommon from './widgetCommon'
import { dateTime, date } from '@/utils/validate'
import { getCurrentYear } from '@/utils/common'
const currentYear = getCurrentYear()
const validatorPattern = (value: string, rule: any) => {
    if (!value) {
      return true
    }
    if (!rule.pattern1.test(value)) {
      return false
    } else {
      return true
    }
  }
@Component({
  components: { 
  }
})
export default class extends Mixins(widgetCommon) {
  private show = false
  private minDate = new Date((currentYear - 100), 0, 1)
  private maxDate = new Date((currentYear + 100), 11, 31)
  private showTime: any = ''

  private get rules () {
    let rules: any = [];
    let pattern1 = this.item.dateType === 1 ? date : dateTime
    let message = this.item.dateType === 1 ? '必须为日期格式' : '必须为日期 + 时间格式'
    rules.push({ validator: validatorPattern, pattern1, message, trigger: 'onBlur' })
    return this.commonRule.concat(rules);
  }
  public initField () {
    if (this.isUndef(this.form[this.item.businessId]) && this.item.defaultType === 1) {
      this.form[this.item.businessId] = this.item.defaultValue || ''
    }
  }
  public resultFn (value) {
    if (value instanceof Date) {
      return getFormatDate(value, this.item.dateType === 1 ? 'date' : 'datetime')
    }
    
  }
  public mounted () {
    if (this.type.includes('record')) {
      this.initField()
    }
  }
  private setDate (val) {
    this.form[this.item.businessId] = this.resultFn(val)
    this.changePopup(false)
  }
  private changePopup (type) {
    if (this.disabled) {
      return
    }
    this.show = type
    if (type) {
      let value = this.form[this.item.businessId]
      this.showTime = value ?  new Date(value) : new Date()
    }
  }// 配置公式传入不是时间字段时 修改
	private changeDate() {
		const { dateType } = this.item;
    const value = this.form[this.item.businessId];
		const pattern = dateType === 1 ? date : dateTime;
		if (value && !pattern.test(value)) {
			this.$emit('input', undefined);
		}
	}
}
